module.exports = __webpack_public_path__ + "static/media/art6.bdc6d29a.png";